import RenderArenaReward from "./RenderArenaReward";
import {useTypedSelector} from "../../../../hooks/useTypedSelector";
import React, {useState} from "react";

function ArenaRenderContainer({items, removeItem}:any) {
    const {user} = useTypedSelector(state => state.auth);

    const [rootActiveClass, setRootActiveClass] = useState('');

    const paid = user.season_progress.progress.paid;
    const free = user.season_progress.progress.free;


    if (items.length > 0 && rootActiveClass === '') {

        setRootActiveClass('test101');

        setTimeout(function(){
            setRootActiveClass('arenaRewardsContainerActive');
        }, 250)
    }


    return <div className={'arenaRewardsContainer ' + rootActiveClass}>
        <div className={'arenaRewardsBoxContainer'}>
            <div className={'arenaRewardTitle'}>
                <div className={'arnaRewardTitleText'}>Info</div>
            </div>
            {(items.length > 0) ?
                <RenderArenaReward items={items} paid={paid} free={free}/>
                :
                <div></div>

            }

            <div className={'arenaRewardOkButton'}
                 onClick={() => {
                     setRootActiveClass('');
                     removeItem();
                 }}
            ></div>

        </div>
    </div>
}

export default ArenaRenderContainer;